// src/components/ErrorBoundary.jsx
import React from 'react';
import { Box, Typography, Button, Paper, Container } from '@mui/material';
import { Error as ErrorIcon, Refresh as RefreshIcon, Home as HomeIcon } from '@mui/icons-material';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      hasError: false, 
      error: null, 
      errorInfo: null 
    };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null, errorInfo: null });
    window.location.reload();
  };

  handleGoHome = () => {
    window.location.href = '/';
  };

  render() {
    if (this.state.hasError) {
      return (
        <Container maxWidth="md" sx={{ mt: 8 }}>
          <Paper sx={{ p: 4, textAlign: 'center' }}>
            <ErrorIcon sx={{ fontSize: 60, color: 'error.main', mb: 2 }} />
            <Typography variant="h4" gutterBottom color="error">
              Что-то пошло не так
            </Typography>
            <Typography variant="body1" sx={{ mb: 3 }}>
              Произошла ошибка в приложении. Мы уже работаем над ее устранением.
            </Typography>
            
            {this.state.error && (
              <Paper sx={{ p: 2, mb: 3, bgcolor: 'error.light', textAlign: 'left' }}>
                <Typography variant="body2" fontFamily="monospace" sx={{ wordBreak: 'break-all' }}>
                  {this.state.error.toString()}
                </Typography>
                {this.state.errorInfo && this.state.errorInfo.componentStack && (
                  <Typography variant="caption" display="block" sx={{ mt: 1 }}>
                    {this.state.errorInfo.componentStack}
                  </Typography>
                )}
              </Paper>
            )}
            
            <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
              <Button
                variant="contained"
                onClick={this.handleReset}
                startIcon={<RefreshIcon />}
                size="large"
              >
                Перезагрузить страницу
              </Button>
              <Button
                variant="outlined"
                onClick={this.handleGoHome}
                startIcon={<HomeIcon />}
                size="large"
              >
                На главную
              </Button>
            </Box>
            
            <Box sx={{ mt: 4, pt: 3, borderTop: 1, borderColor: 'divider' }}>
              <Typography variant="body2" color="text.secondary">
                Если ошибка повторяется, обратитесь в поддержку
              </Typography>
            </Box>
          </Paper>
        </Container>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;